export default __webpack_public_path__ + "static/media/chat_bot_image2.b10b6c92.jpg";